package br.com.logicalside.proposes.components.sections

import Res
import androidx.compose.runtime.Composable
import br.com.logicalside.proposes.BodyTextStyle
import br.com.logicalside.proposes.Headline4TextStyle
import br.com.logicalside.proposes.TitleTextStyle
import br.com.logicalside.proposes.components.layouts.InnerContainer
import br.com.logicalside.proposes.toSitePalette
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.breakpoint.displayUntil
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun AboutSection() {
    InnerContainer(AboutContainerStyle.toModifier().id("about")) {
        Row(Modifier.displayIfAtLeast(Breakpoint.MD)) {
            AboutContent()
            AboutImage()
        }

        Column(Modifier.displayUntil(Breakpoint.MD), horizontalAlignment = Alignment.CenterHorizontally) {
            AboutImage()
            AboutContent()
        }
    }
}

@Composable
private fun AboutContent() {
    Column(AboutContentStyle.toModifier()) {
        SpanText(
            Res.string.about_title,
            Headline4TextStyle.toModifier().then(AboutTitleStyle.toModifier())
        )
        P(BodyTextStyle.toModifier().then(AboutDescriptionStyle.toModifier()).toAttrs()) {
            Div {
                Text(Res.string.about_description_1)
            }
            Div(Modifier.margin(top = 1.cssRem).toAttrs()) {
                Text(Res.string.about_description_2)
            }
        }
    }
}

@Composable
private fun AboutImage() {
    Image(
        "/about.png",
        "About the app",
        AboutImageStyle.toModifier()
    )
}

val AboutContainerStyle = CssStyle.base {
    Modifier
        .fillMaxWidth()
        .padding(topBottom = 6.cssRem, leftRight = 2.cssRem)
}

val AboutContentStyle = CssStyle {
    Breakpoint.MD { Modifier.padding(right = 2.cssRem) }
}

val AboutTitleStyle = CssStyle {
    base {
        Modifier
            .fontWeight(FontWeight.SemiBold)
            .color(colorMode.toSitePalette().onBackground)
            .textAlign(TextAlign.Center)
    }
    Breakpoint.MD { Modifier.textAlign(TextAlign.Start) }
}

val AboutDescriptionStyle = CssStyle {
    base {
        Modifier
            .color(colorMode.toSitePalette().onBackground)
            .textAlign(TextAlign.Center)
    }
    Breakpoint.MD { Modifier.textAlign(TextAlign.Start) }
}

val AboutImageStyle = CssStyle {
    base { Modifier.height(14.cssRem).display(DisplayStyle.Block).padding(bottom = 2.cssRem) }
    Breakpoint.MD { Modifier.height(14.cssRem).padding(left = 4.cssRem) }
    Breakpoint.LG { Modifier.height(18.cssRem).padding(left = 4.cssRem) }
}
